/* @generated from adl module ferovinum.app.reporting */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as common_tabular from './../../common/tabular';
import * as ferovinum_app_db from './db';
import * as sys_types from './../../sys/types';

export interface Value_B {
  kind: 'b';
  value: boolean;
}
export interface Value_D {
  kind: 'd';
  value: number;
}
export interface Value_Dt {
  kind: 'dt';
  value: common.LocalDate;
}
export interface Value_I64 {
  kind: 'i64';
  value: number;
}
export interface Value_J {
  kind: 'j';
  value: {}|null;
}
export interface Value_N {
  kind: 'n';
}
export interface Value_S {
  kind: 's';
  value: string;
}
export interface Value_Ts {
  kind: 'ts';
  value: common.LocalDateTime;
}

export type Value = Value_B | Value_D | Value_Dt | Value_I64 | Value_J | Value_N | Value_S | Value_Ts;

export interface ValueOpts {
  b: boolean;
  d: number;
  dt: common.LocalDate;
  i64: number;
  j: {}|null;
  n: null;
  s: string;
  ts: common.LocalDateTime;
}

export function makeValue<K extends keyof ValueOpts>(kind: K, value: ValueOpts[K]) { return {kind, value}; }

const Value_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"b","default":{"kind":"nothing"},"name":"b","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"d","default":{"kind":"nothing"},"name":"d","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"dt","default":{"kind":"nothing"},"name":"dt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"i64","default":{"kind":"nothing"},"name":"i64","typeExpr":{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}},{"annotations":[],"serializedName":"j","default":{"kind":"nothing"},"name":"j","typeExpr":{"typeRef":{"kind":"primitive","value":"Json"},"parameters":[]}},{"annotations":[],"serializedName":"n","default":{"kind":"nothing"},"name":"n","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"s","default":{"kind":"nothing"},"name":"s","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"ts","default":{"kind":"nothing"},"name":"ts","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDateTime"}},"parameters":[]}}]}},"name":"Value","version":{"kind":"nothing"}}};

export const snValue: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"Value"};

export function texprValue(): ADL.ATypeExpr<Value> {
  return {value : {typeRef : {kind: "reference", value : snValue}, parameters : []}};
}

export interface Error {
  message: string;
}

export function makeError(
  input: {
    message: string,
  }
): Error {
  return {
    message: input.message,
  };
}

const Error_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"message","default":{"kind":"nothing"},"name":"message","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"Error","version":{"kind":"nothing"}}};

export const snError: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"Error"};

export function texprError(): ADL.ATypeExpr<Error> {
  return {value : {typeRef : {kind: "reference", value : snError}, parameters : []}};
}

export type EType<T> = sys_types.Either<T, Error>;

const EType_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":["T"],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Either"}},"parameters":[{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"Error"}},"parameters":[]}]}}},"name":"EType","version":{"kind":"nothing"}}};

export const snEType: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"EType"};

export function texprEType<T>(texprT : ADL.ATypeExpr<T>): ADL.ATypeExpr<EType<T>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "ferovinum.app.reporting",name : "EType"}}, parameters : [texprT.value]}};
}

export type EValue = EType<Value>;

const EValue_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EType"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"Value"}},"parameters":[]}]}}},"name":"EValue","version":{"kind":"nothing"}}};

export const snEValue: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"EValue"};

export function texprEValue(): ADL.ATypeExpr<EValue> {
  return {value : {typeRef : {kind: "reference", value : snEValue}, parameters : []}};
}

export interface BiFunctionInput {
  x: string;
  y: string;
}

export function makeBiFunctionInput(
  input: {
    x: string,
    y: string,
  }
): BiFunctionInput {
  return {
    x: input.x,
    y: input.y,
  };
}

const BiFunctionInput_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"x","default":{"kind":"nothing"},"name":"x","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"y","default":{"kind":"nothing"},"name":"y","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"BiFunctionInput","version":{"kind":"nothing"}}};

export const snBiFunctionInput: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"BiFunctionInput"};

export function texprBiFunctionInput(): ADL.ATypeExpr<BiFunctionInput> {
  return {value : {typeRef : {kind: "reference", value : snBiFunctionInput}, parameters : []}};
}

export interface Operator_Sum {
  kind: 'sum';
  value: BiFunctionInput;
}
export interface Operator_Difference {
  kind: 'difference';
  value: BiFunctionInput;
}
export interface Operator_Multiply {
  kind: 'multiply';
  value: BiFunctionInput;
}
export interface Operator_Division {
  kind: 'division';
  value: BiFunctionInput;
}

export type Operator = Operator_Sum | Operator_Difference | Operator_Multiply | Operator_Division;

export interface OperatorOpts {
  sum: BiFunctionInput;
  difference: BiFunctionInput;
  multiply: BiFunctionInput;
  division: BiFunctionInput;
}

export function makeOperator<K extends keyof OperatorOpts>(kind: K, value: OperatorOpts[K]) { return {kind, value}; }

const Operator_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"sum","default":{"kind":"nothing"},"name":"sum","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"BiFunctionInput"}},"parameters":[]}},{"annotations":[],"serializedName":"difference","default":{"kind":"nothing"},"name":"difference","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"BiFunctionInput"}},"parameters":[]}},{"annotations":[],"serializedName":"multiply","default":{"kind":"nothing"},"name":"multiply","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"BiFunctionInput"}},"parameters":[]}},{"annotations":[],"serializedName":"division","default":{"kind":"nothing"},"name":"division","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"BiFunctionInput"}},"parameters":[]}}]}},"name":"Operator","version":{"kind":"nothing"}}};

export const snOperator: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"Operator"};

export function texprOperator(): ADL.ATypeExpr<Operator> {
  return {value : {typeRef : {kind: "reference", value : snOperator}, parameters : []}};
}

export interface AttributeOpP {
  name: string;
  operator: Operator;
}

export function makeAttributeOpP(
  input: {
    name: string,
    operator: Operator,
  }
): AttributeOpP {
  return {
    name: input.name,
    operator: input.operator,
  };
}

const AttributeOpP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"operator","default":{"kind":"nothing"},"name":"operator","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"Operator"}},"parameters":[]}}]}},"name":"AttributeOpP","version":{"kind":"nothing"}}};

export const snAttributeOpP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"AttributeOpP"};

export function texprAttributeOpP(): ADL.ATypeExpr<AttributeOpP> {
  return {value : {typeRef : {kind: "reference", value : snAttributeOpP}, parameters : []}};
}

export interface AttributeOpE {
  name: string;
  value: EValue;
}

export function makeAttributeOpE(
  input: {
    name: string,
    value: EValue,
  }
): AttributeOpE {
  return {
    name: input.name,
    value: input.value,
  };
}

const AttributeOpE_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EValue"}},"parameters":[]}}]}},"name":"AttributeOpE","version":{"kind":"nothing"}}};

export const snAttributeOpE: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"AttributeOpE"};

export function texprAttributeOpE(): ADL.ATypeExpr<AttributeOpE> {
  return {value : {typeRef : {kind: "reference", value : snAttributeOpE}, parameters : []}};
}

export type AttributeOpR = EType<AttributeOpE>;

const AttributeOpR_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EType"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"AttributeOpE"}},"parameters":[]}]}}},"name":"AttributeOpR","version":{"kind":"nothing"}}};

export const snAttributeOpR: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"AttributeOpR"};

export function texprAttributeOpR(): ADL.ATypeExpr<AttributeOpR> {
  return {value : {typeRef : {kind: "reference", value : snAttributeOpR}, parameters : []}};
}

export interface BagP {
  reportParams: Param[];
}

export function makeBagP(
  input: {
    reportParams: Param[],
  }
): BagP {
  return {
    reportParams: input.reportParams,
  };
}

const BagP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"reportParams","default":{"kind":"nothing"},"name":"reportParams","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"Param"}},"parameters":[]}]}}]}},"name":"BagP","version":{"kind":"nothing"}}};

export const snBagP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"BagP"};

export function texprBagP(): ADL.ATypeExpr<BagP> {
  return {value : {typeRef : {kind: "reference", value : snBagP}, parameters : []}};
}

export type BagR = EType<Result[]>;

const BagR_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EType"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"Result"}},"parameters":[]}]}]}}},"name":"BagR","version":{"kind":"nothing"}}};

export const snBagR: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"BagR"};

export function texprBagR(): ADL.ATypeExpr<BagR> {
  return {value : {typeRef : {kind: "reference", value : snBagR}, parameters : []}};
}

export interface FxSpotP {
  baseCurrency: common_strings.StringNE;
  quoteCurrency: common_strings.StringNE;
  date: (common.LocalDate|null);
}

export function makeFxSpotP(
  input: {
    baseCurrency: common_strings.StringNE,
    quoteCurrency: common_strings.StringNE,
    date?: (common.LocalDate|null),
  }
): FxSpotP {
  return {
    baseCurrency: input.baseCurrency,
    quoteCurrency: input.quoteCurrency,
    date: input.date === undefined ? null : input.date,
  };
}

const FxSpotP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"baseCurrency","default":{"kind":"nothing"},"name":"baseCurrency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"quoteCurrency","default":{"kind":"nothing"},"name":"quoteCurrency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"date","default":{"kind":"just","value":null},"name":"date","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}}]}},"name":"FxSpotP","version":{"kind":"nothing"}}};

export const snFxSpotP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"FxSpotP"};

export function texprFxSpotP(): ADL.ATypeExpr<FxSpotP> {
  return {value : {typeRef : {kind: "reference", value : snFxSpotP}, parameters : []}};
}

export interface FxSpotE {
  baseCurrency: common_strings.StringNE;
  quoteCurrency: common_strings.StringNE;
  exchangeRate: common.BigDecimal;
  date: common.LocalDate;
}

export function makeFxSpotE(
  input: {
    baseCurrency: common_strings.StringNE,
    quoteCurrency: common_strings.StringNE,
    exchangeRate: common.BigDecimal,
    date: common.LocalDate,
  }
): FxSpotE {
  return {
    baseCurrency: input.baseCurrency,
    quoteCurrency: input.quoteCurrency,
    exchangeRate: input.exchangeRate,
    date: input.date,
  };
}

const FxSpotE_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"baseCurrency","default":{"kind":"nothing"},"name":"baseCurrency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"quoteCurrency","default":{"kind":"nothing"},"name":"quoteCurrency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"exchangeRate","default":{"kind":"nothing"},"name":"exchangeRate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"date","default":{"kind":"nothing"},"name":"date","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}}]}},"name":"FxSpotE","version":{"kind":"nothing"}}};

export const snFxSpotE: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"FxSpotE"};

export function texprFxSpotE(): ADL.ATypeExpr<FxSpotE> {
  return {value : {typeRef : {kind: "reference", value : snFxSpotE}, parameters : []}};
}

export type FxSpotR = EType<FxSpotE[]>;

const FxSpotR_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EType"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"FxSpotE"}},"parameters":[]}]}]}}},"name":"FxSpotR","version":{"kind":"nothing"}}};

export const snFxSpotR: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"FxSpotR"};

export function texprFxSpotR(): ADL.ATypeExpr<FxSpotR> {
  return {value : {typeRef : {kind: "reference", value : snFxSpotR}, parameters : []}};
}

export interface CashflowP {
  fromDate: (common.LocalDate|null);
  toDate: (common.LocalDate|null);
  includeContingent: boolean;
  netPurchaseDeposit: boolean;
  netSaleDeposit: boolean;
}

export function makeCashflowP(
  input: {
    fromDate?: (common.LocalDate|null),
    toDate?: (common.LocalDate|null),
    includeContingent?: boolean,
    netPurchaseDeposit?: boolean,
    netSaleDeposit?: boolean,
  }
): CashflowP {
  return {
    fromDate: input.fromDate === undefined ? null : input.fromDate,
    toDate: input.toDate === undefined ? null : input.toDate,
    includeContingent: input.includeContingent === undefined ? true : input.includeContingent,
    netPurchaseDeposit: input.netPurchaseDeposit === undefined ? true : input.netPurchaseDeposit,
    netSaleDeposit: input.netSaleDeposit === undefined ? true : input.netSaleDeposit,
  };
}

const CashflowP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"fromDate","default":{"kind":"just","value":null},"name":"fromDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"toDate","default":{"kind":"just","value":null},"name":"toDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"includeContingent","default":{"kind":"just","value":true},"name":"includeContingent","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"netPurchaseDeposit","default":{"kind":"just","value":true},"name":"netPurchaseDeposit","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"netSaleDeposit","default":{"kind":"just","value":true},"name":"netSaleDeposit","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"CashflowP","version":{"kind":"nothing"}}};

export const snCashflowP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"CashflowP"};

export function texprCashflowP(): ADL.ATypeExpr<CashflowP> {
  return {value : {typeRef : {kind: "reference", value : snCashflowP}, parameters : []}};
}

export interface CashflowE {
  date: common.LocalDate;
  description: string;
  reference: string;
  currency: common_strings.StringNE;
  amount: common.BigDecimal;
  contingent: boolean;
}

export function makeCashflowE(
  input: {
    date: common.LocalDate,
    description: string,
    reference: string,
    currency: common_strings.StringNE,
    amount: common.BigDecimal,
    contingent: boolean,
  }
): CashflowE {
  return {
    date: input.date,
    description: input.description,
    reference: input.reference,
    currency: input.currency,
    amount: input.amount,
    contingent: input.contingent,
  };
}

const CashflowE_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"date","default":{"kind":"nothing"},"name":"date","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"reference","default":{"kind":"nothing"},"name":"reference","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"amount","default":{"kind":"nothing"},"name":"amount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"contingent","default":{"kind":"nothing"},"name":"contingent","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"CashflowE","version":{"kind":"nothing"}}};

export const snCashflowE: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"CashflowE"};

export function texprCashflowE(): ADL.ATypeExpr<CashflowE> {
  return {value : {typeRef : {kind: "reference", value : snCashflowE}, parameters : []}};
}

export type CashflowR = EType<CashflowE[]>;

const CashflowR_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EType"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"CashflowE"}},"parameters":[]}]}]}}},"name":"CashflowR","version":{"kind":"nothing"}}};

export const snCashflowR: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"CashflowR"};

export function texprCashflowR(): ADL.ATypeExpr<CashflowR> {
  return {value : {typeRef : {kind: "reference", value : snCashflowR}, parameters : []}};
}

export interface DealCountP {
  includePreDeal: boolean;
}

export function makeDealCountP(
  input: {
    includePreDeal?: boolean,
  }
): DealCountP {
  return {
    includePreDeal: input.includePreDeal === undefined ? false : input.includePreDeal,
  };
}

const DealCountP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"includePreDeal","default":{"kind":"just","value":false},"name":"includePreDeal","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"DealCountP","version":{"kind":"nothing"}}};

export const snDealCountP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"DealCountP"};

export function texprDealCountP(): ADL.ATypeExpr<DealCountP> {
  return {value : {typeRef : {kind: "reference", value : snDealCountP}, parameters : []}};
}

export type DealCountR = EType<number>;

const DealCountR_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EType"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}]}}},"name":"DealCountR","version":{"kind":"nothing"}}};

export const snDealCountR: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"DealCountR"};

export function texprDealCountR(): ADL.ATypeExpr<DealCountR> {
  return {value : {typeRef : {kind: "reference", value : snDealCountR}, parameters : []}};
}

export interface DealRollCountP {
  includeApplications: (ferovinum_app_db.DealRollApplication[]|null);
}

export function makeDealRollCountP(
  input: {
    includeApplications?: (ferovinum_app_db.DealRollApplication[]|null),
  }
): DealRollCountP {
  return {
    includeApplications: input.includeApplications === undefined ? null : input.includeApplications,
  };
}

const DealRollCountP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"includeApplications","default":{"kind":"just","value":null},"name":"includeApplications","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DealRollApplication"}},"parameters":[]}]}]}}]}},"name":"DealRollCountP","version":{"kind":"nothing"}}};

export const snDealRollCountP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"DealRollCountP"};

export function texprDealRollCountP(): ADL.ATypeExpr<DealRollCountP> {
  return {value : {typeRef : {kind: "reference", value : snDealRollCountP}, parameters : []}};
}

export type DealRollCountR = EType<number>;

const DealRollCountR_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EType"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Int64"},"parameters":[]}]}}},"name":"DealRollCountR","version":{"kind":"nothing"}}};

export const snDealRollCountR: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"DealRollCountR"};

export function texprDealRollCountR(): ADL.ATypeExpr<DealRollCountR> {
  return {value : {typeRef : {kind: "reference", value : snDealRollCountR}, parameters : []}};
}

export interface DealRollHistoryP {
  fromDate: (common.LocalDate|null);
  toDate: (common.LocalDate|null);
  recursiveSearch: boolean;
  stopOnExpiry: boolean;
}

export function makeDealRollHistoryP(
  input: {
    fromDate?: (common.LocalDate|null),
    toDate?: (common.LocalDate|null),
    recursiveSearch?: boolean,
    stopOnExpiry?: boolean,
  }
): DealRollHistoryP {
  return {
    fromDate: input.fromDate === undefined ? null : input.fromDate,
    toDate: input.toDate === undefined ? null : input.toDate,
    recursiveSearch: input.recursiveSearch === undefined ? false : input.recursiveSearch,
    stopOnExpiry: input.stopOnExpiry === undefined ? false : input.stopOnExpiry,
  };
}

const DealRollHistoryP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"fromDate","default":{"kind":"just","value":null},"name":"fromDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"toDate","default":{"kind":"just","value":null},"name":"toDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"recursiveSearch","default":{"kind":"just","value":false},"name":"recursiveSearch","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"stopOnExpiry","default":{"kind":"just","value":false},"name":"stopOnExpiry","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"DealRollHistoryP","version":{"kind":"nothing"}}};

export const snDealRollHistoryP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"DealRollHistoryP"};

export function texprDealRollHistoryP(): ADL.ATypeExpr<DealRollHistoryP> {
  return {value : {typeRef : {kind: "reference", value : snDealRollHistoryP}, parameters : []}};
}

export interface DealRollHistoryE {
  date: common.LocalDate;
  application: ferovinum_app_db.DealRollApplication;
  reference: string;
  fromDealLeg: ferovinum_app_db.DealLegId;
  toDealLeg: ferovinum_app_db.DealLegId;
  units: number;
}

export function makeDealRollHistoryE(
  input: {
    date: common.LocalDate,
    application: ferovinum_app_db.DealRollApplication,
    reference: string,
    fromDealLeg: ferovinum_app_db.DealLegId,
    toDealLeg: ferovinum_app_db.DealLegId,
    units: number,
  }
): DealRollHistoryE {
  return {
    date: input.date,
    application: input.application,
    reference: input.reference,
    fromDealLeg: input.fromDealLeg,
    toDealLeg: input.toDealLeg,
    units: input.units,
  };
}

const DealRollHistoryE_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"date","default":{"kind":"nothing"},"name":"date","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"application","default":{"kind":"nothing"},"name":"application","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DealRollApplication"}},"parameters":[]}},{"annotations":[],"serializedName":"reference","default":{"kind":"nothing"},"name":"reference","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"fromDealLeg","default":{"kind":"nothing"},"name":"fromDealLeg","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DealLegId"}},"parameters":[]}},{"annotations":[],"serializedName":"toDealLeg","default":{"kind":"nothing"},"name":"toDealLeg","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DealLegId"}},"parameters":[]}},{"annotations":[],"serializedName":"units","default":{"kind":"nothing"},"name":"units","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}]}},"name":"DealRollHistoryE","version":{"kind":"nothing"}}};

export const snDealRollHistoryE: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"DealRollHistoryE"};

export function texprDealRollHistoryE(): ADL.ATypeExpr<DealRollHistoryE> {
  return {value : {typeRef : {kind: "reference", value : snDealRollHistoryE}, parameters : []}};
}

export type DealRollHistoryR = EType<DealRollHistoryE[]>;

const DealRollHistoryR_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EType"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"DealRollHistoryE"}},"parameters":[]}]}]}}},"name":"DealRollHistoryR","version":{"kind":"nothing"}}};

export const snDealRollHistoryR: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"DealRollHistoryR"};

export function texprDealRollHistoryR(): ADL.ATypeExpr<DealRollHistoryR> {
  return {value : {typeRef : {kind: "reference", value : snDealRollHistoryR}, parameters : []}};
}

export interface DepletionForecastP {
  includeRelatedProducts: boolean;
}

export function makeDepletionForecastP(
  input: {
    includeRelatedProducts?: boolean,
  }
): DepletionForecastP {
  return {
    includeRelatedProducts: input.includeRelatedProducts === undefined ? false : input.includeRelatedProducts,
  };
}

const DepletionForecastP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"includeRelatedProducts","default":{"kind":"just","value":false},"name":"includeRelatedProducts","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"DepletionForecastP","version":{"kind":"nothing"}}};

export const snDepletionForecastP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"DepletionForecastP"};

export function texprDepletionForecastP(): ADL.ATypeExpr<DepletionForecastP> {
  return {value : {typeRef : {kind: "reference", value : snDepletionForecastP}, parameters : []}};
}

export interface DepletionForecastE {
  predictedFinalDate: common.LocalDate;
  predictedUnitsAtCompulsorySaleDate: number;
  rateOfSale: number;
}

export function makeDepletionForecastE(
  input: {
    predictedFinalDate: common.LocalDate,
    predictedUnitsAtCompulsorySaleDate: number,
    rateOfSale: number,
  }
): DepletionForecastE {
  return {
    predictedFinalDate: input.predictedFinalDate,
    predictedUnitsAtCompulsorySaleDate: input.predictedUnitsAtCompulsorySaleDate,
    rateOfSale: input.rateOfSale,
  };
}

const DepletionForecastE_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"predictedFinalDate","default":{"kind":"nothing"},"name":"predictedFinalDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"predictedUnitsAtCompulsorySaleDate","default":{"kind":"nothing"},"name":"predictedUnitsAtCompulsorySaleDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"rateOfSale","default":{"kind":"nothing"},"name":"rateOfSale","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}]}},"name":"DepletionForecastE","version":{"kind":"nothing"}}};

export const snDepletionForecastE: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"DepletionForecastE"};

export function texprDepletionForecastE(): ADL.ATypeExpr<DepletionForecastE> {
  return {value : {typeRef : {kind: "reference", value : snDepletionForecastE}, parameters : []}};
}

export type DepletionForecastR = EType<DepletionForecastE[]>;

const DepletionForecastR_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EType"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"DepletionForecastE"}},"parameters":[]}]}]}}},"name":"DepletionForecastR","version":{"kind":"nothing"}}};

export const snDepletionForecastR: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"DepletionForecastR"};

export function texprDepletionForecastR(): ADL.ATypeExpr<DepletionForecastR> {
  return {value : {typeRef : {kind: "reference", value : snDepletionForecastR}, parameters : []}};
}

export interface FeeP {
  annualised: boolean;
}

export function makeFeeP(
  input: {
    annualised?: boolean,
  }
): FeeP {
  return {
    annualised: input.annualised === undefined ? false : input.annualised,
  };
}

const FeeP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"annualised","default":{"kind":"just","value":false},"name":"annualised","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"FeeP","version":{"kind":"nothing"}}};

export const snFeeP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"FeeP"};

export function texprFeeP(): ADL.ATypeExpr<FeeP> {
  return {value : {typeRef : {kind: "reference", value : snFeeP}, parameters : []}};
}

export interface FeeE {
  monthly: common.BigDecimal;
  throughput: common.BigDecimal;
  fulfilment: common.BigDecimal;
}

export function makeFeeE(
  input: {
    monthly: common.BigDecimal,
    throughput: common.BigDecimal,
    fulfilment: common.BigDecimal,
  }
): FeeE {
  return {
    monthly: input.monthly,
    throughput: input.throughput,
    fulfilment: input.fulfilment,
  };
}

const FeeE_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"monthly","default":{"kind":"nothing"},"name":"monthly","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"throughput","default":{"kind":"nothing"},"name":"throughput","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"fulfilment","default":{"kind":"nothing"},"name":"fulfilment","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"FeeE","version":{"kind":"nothing"}}};

export const snFeeE: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"FeeE"};

export function texprFeeE(): ADL.ATypeExpr<FeeE> {
  return {value : {typeRef : {kind: "reference", value : snFeeE}, parameters : []}};
}

export type FeeR = EType<FeeE>;

const FeeR_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EType"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"FeeE"}},"parameters":[]}]}}},"name":"FeeR","version":{"kind":"nothing"}}};

export const snFeeR: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"FeeR"};

export function texprFeeR(): ADL.ATypeExpr<FeeR> {
  return {value : {typeRef : {kind: "reference", value : snFeeR}, parameters : []}};
}

export interface FspP {
  enableRounding: boolean;
  includeCapExBreakdown: boolean;
  traceDealRoll: boolean;
  separateCapExFee: boolean;
}

export function makeFspP(
  input: {
    enableRounding?: boolean,
    includeCapExBreakdown?: boolean,
    traceDealRoll?: boolean,
    separateCapExFee?: boolean,
  }
): FspP {
  return {
    enableRounding: input.enableRounding === undefined ? true : input.enableRounding,
    includeCapExBreakdown: input.includeCapExBreakdown === undefined ? true : input.includeCapExBreakdown,
    traceDealRoll: input.traceDealRoll === undefined ? false : input.traceDealRoll,
    separateCapExFee: input.separateCapExFee === undefined ? false : input.separateCapExFee,
  };
}

const FspP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"enableRounding","default":{"kind":"just","value":true},"name":"enableRounding","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"includeCapExBreakdown","default":{"kind":"just","value":true},"name":"includeCapExBreakdown","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"traceDealRoll","default":{"kind":"just","value":false},"name":"traceDealRoll","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"separateCapExFee","default":{"kind":"just","value":false},"name":"separateCapExFee","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"FspP","version":{"kind":"nothing"}}};

export const snFspP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"FspP"};

export function texprFspP(): ADL.ATypeExpr<FspP> {
  return {value : {typeRef : {kind: "reference", value : snFspP}, parameters : []}};
}

export interface FspCapExE {
  id: ferovinum_app_db.CapitalisedExpenseId;
  expenseDate: common.LocalDate;
  totalPrice: common.BigDecimal;
  basePrice: common.BigDecimal;
  monthlyFee: common.BigDecimal;
  throughputFee: common.BigDecimal;
}

export function makeFspCapExE(
  input: {
    id: ferovinum_app_db.CapitalisedExpenseId,
    expenseDate: common.LocalDate,
    totalPrice: common.BigDecimal,
    basePrice: common.BigDecimal,
    monthlyFee: common.BigDecimal,
    throughputFee: common.BigDecimal,
  }
): FspCapExE {
  return {
    id: input.id,
    expenseDate: input.expenseDate,
    totalPrice: input.totalPrice,
    basePrice: input.basePrice,
    monthlyFee: input.monthlyFee,
    throughputFee: input.throughputFee,
  };
}

const FspCapExE_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"CapitalisedExpenseId"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseDate","default":{"kind":"nothing"},"name":"expenseDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"totalPrice","default":{"kind":"nothing"},"name":"totalPrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"basePrice","default":{"kind":"nothing"},"name":"basePrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"monthlyFee","default":{"kind":"nothing"},"name":"monthlyFee","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"throughputFee","default":{"kind":"nothing"},"name":"throughputFee","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"FspCapExE","version":{"kind":"nothing"}}};

export const snFspCapExE: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"FspCapExE"};

export function texprFspCapExE(): ADL.ATypeExpr<FspCapExE> {
  return {value : {typeRef : {kind: "reference", value : snFspCapExE}, parameters : []}};
}

export interface FspE {
  totalPrice: common.BigDecimal;
  basePrice: common.BigDecimal;
  depositPrice: common.BigDecimal;
  monthlyFee: common.BigDecimal;
  throughputFee: common.BigDecimal;
  capitalisedExpenseTotalPrice: common.BigDecimal;
  capitalisedExpenseBasePrice: common.BigDecimal;
  capitalisedExpenseMonthlyFee: common.BigDecimal;
  capitalisedExpenseThroughputFee: common.BigDecimal;
  capitalisedExpenses: FspCapExE[];
  residualRounding: common.BigDecimal;
}

export function makeFspE(
  input: {
    totalPrice: common.BigDecimal,
    basePrice: common.BigDecimal,
    depositPrice: common.BigDecimal,
    monthlyFee: common.BigDecimal,
    throughputFee: common.BigDecimal,
    capitalisedExpenseTotalPrice: common.BigDecimal,
    capitalisedExpenseBasePrice: common.BigDecimal,
    capitalisedExpenseMonthlyFee: common.BigDecimal,
    capitalisedExpenseThroughputFee: common.BigDecimal,
    capitalisedExpenses: FspCapExE[],
    residualRounding: common.BigDecimal,
  }
): FspE {
  return {
    totalPrice: input.totalPrice,
    basePrice: input.basePrice,
    depositPrice: input.depositPrice,
    monthlyFee: input.monthlyFee,
    throughputFee: input.throughputFee,
    capitalisedExpenseTotalPrice: input.capitalisedExpenseTotalPrice,
    capitalisedExpenseBasePrice: input.capitalisedExpenseBasePrice,
    capitalisedExpenseMonthlyFee: input.capitalisedExpenseMonthlyFee,
    capitalisedExpenseThroughputFee: input.capitalisedExpenseThroughputFee,
    capitalisedExpenses: input.capitalisedExpenses,
    residualRounding: input.residualRounding,
  };
}

const FspE_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"totalPrice","default":{"kind":"nothing"},"name":"totalPrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"basePrice","default":{"kind":"nothing"},"name":"basePrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"depositPrice","default":{"kind":"nothing"},"name":"depositPrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"monthlyFee","default":{"kind":"nothing"},"name":"monthlyFee","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"throughputFee","default":{"kind":"nothing"},"name":"throughputFee","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"capitalisedExpenseTotalPrice","default":{"kind":"nothing"},"name":"capitalisedExpenseTotalPrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"capitalisedExpenseBasePrice","default":{"kind":"nothing"},"name":"capitalisedExpenseBasePrice","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"capitalisedExpenseMonthlyFee","default":{"kind":"nothing"},"name":"capitalisedExpenseMonthlyFee","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"capitalisedExpenseThroughputFee","default":{"kind":"nothing"},"name":"capitalisedExpenseThroughputFee","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"capitalisedExpenses","default":{"kind":"nothing"},"name":"capitalisedExpenses","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"FspCapExE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"residualRounding","default":{"kind":"nothing"},"name":"residualRounding","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"FspE","version":{"kind":"nothing"}}};

export const snFspE: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"FspE"};

export function texprFspE(): ADL.ATypeExpr<FspE> {
  return {value : {typeRef : {kind: "reference", value : snFspE}, parameters : []}};
}

export type FspR = EType<FspE>;

const FspR_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EType"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"FspE"}},"parameters":[]}]}}},"name":"FspR","version":{"kind":"nothing"}}};

export const snFspR: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"FspR"};

export function texprFspR(): ADL.ATypeExpr<FspR> {
  return {value : {typeRef : {kind: "reference", value : snFspR}, parameters : []}};
}

export interface InitialUnitsP {
  normalise: boolean;
}

export function makeInitialUnitsP(
  input: {
    normalise?: boolean,
  }
): InitialUnitsP {
  return {
    normalise: input.normalise === undefined ? true : input.normalise,
  };
}

const InitialUnitsP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"normalise","default":{"kind":"just","value":true},"name":"normalise","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"InitialUnitsP","version":{"kind":"nothing"}}};

export const snInitialUnitsP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"InitialUnitsP"};

export function texprInitialUnitsP(): ADL.ATypeExpr<InitialUnitsP> {
  return {value : {typeRef : {kind: "reference", value : snInitialUnitsP}, parameters : []}};
}

export interface InitialUnitsE {
  productCode: common_strings.StringNE;
  units: number;
}

export function makeInitialUnitsE(
  input: {
    productCode: common_strings.StringNE,
    units: number,
  }
): InitialUnitsE {
  return {
    productCode: input.productCode,
    units: input.units,
  };
}

const InitialUnitsE_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"productCode","default":{"kind":"nothing"},"name":"productCode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"units","default":{"kind":"nothing"},"name":"units","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}]}},"name":"InitialUnitsE","version":{"kind":"nothing"}}};

export const snInitialUnitsE: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"InitialUnitsE"};

export function texprInitialUnitsE(): ADL.ATypeExpr<InitialUnitsE> {
  return {value : {typeRef : {kind: "reference", value : snInitialUnitsE}, parameters : []}};
}

export type InitialUnitsR = EType<InitialUnitsE[]>;

const InitialUnitsR_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EType"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"InitialUnitsE"}},"parameters":[]}]}]}}},"name":"InitialUnitsR","version":{"kind":"nothing"}}};

export const snInitialUnitsR: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"InitialUnitsR"};

export function texprInitialUnitsR(): ADL.ATypeExpr<InitialUnitsR> {
  return {value : {typeRef : {kind: "reference", value : snInitialUnitsR}, parameters : []}};
}

export interface MonthlyFeeNextDateP {
  pivotDate: (common.LocalDate|null);
}

export function makeMonthlyFeeNextDateP(
  input: {
    pivotDate: (common.LocalDate|null),
  }
): MonthlyFeeNextDateP {
  return {
    pivotDate: input.pivotDate,
  };
}

const MonthlyFeeNextDateP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"pivotDate","default":{"kind":"nothing"},"name":"pivotDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}}]}},"name":"MonthlyFeeNextDateP","version":{"kind":"nothing"}}};

export const snMonthlyFeeNextDateP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"MonthlyFeeNextDateP"};

export function texprMonthlyFeeNextDateP(): ADL.ATypeExpr<MonthlyFeeNextDateP> {
  return {value : {typeRef : {kind: "reference", value : snMonthlyFeeNextDateP}, parameters : []}};
}

export type MonthlyFeeNextDateR = EType<common.LocalDate[]>;

const MonthlyFeeNextDateR_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EType"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}]}}},"name":"MonthlyFeeNextDateR","version":{"kind":"nothing"}}};

export const snMonthlyFeeNextDateR: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"MonthlyFeeNextDateR"};

export function texprMonthlyFeeNextDateR(): ADL.ATypeExpr<MonthlyFeeNextDateR> {
  return {value : {typeRef : {kind: "reference", value : snMonthlyFeeNextDateR}, parameters : []}};
}

export interface PerDealP {
  attributes: string[];
  reportParam: Param;
}

export function makePerDealP(
  input: {
    attributes: string[],
    reportParam: Param,
  }
): PerDealP {
  return {
    attributes: input.attributes,
    reportParam: input.reportParam,
  };
}

const PerDealP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"attributes","default":{"kind":"nothing"},"name":"attributes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"reportParam","default":{"kind":"nothing"},"name":"reportParam","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"Param"}},"parameters":[]}}]}},"name":"PerDealP","version":{"kind":"nothing"}}};

export const snPerDealP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"PerDealP"};

export function texprPerDealP(): ADL.ATypeExpr<PerDealP> {
  return {value : {typeRef : {kind: "reference", value : snPerDealP}, parameters : []}};
}

export type PerDealE = sys_types.Pair<sys_types.Map<string, EValue>, Result>;

const PerDealE_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Pair"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Map"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]},{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EValue"}},"parameters":[]}]},{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"Result"}},"parameters":[]}]}}},"name":"PerDealE","version":{"kind":"nothing"}}};

export const snPerDealE: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"PerDealE"};

export function texprPerDealE(): ADL.ATypeExpr<PerDealE> {
  return {value : {typeRef : {kind: "reference", value : snPerDealE}, parameters : []}};
}

export type PerDealR = EType<PerDealE[]>;

const PerDealR_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EType"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"PerDealE"}},"parameters":[]}]}]}}},"name":"PerDealR","version":{"kind":"nothing"}}};

export const snPerDealR: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"PerDealR"};

export function texprPerDealR(): ADL.ATypeExpr<PerDealR> {
  return {value : {typeRef : {kind: "reference", value : snPerDealR}, parameters : []}};
}

export interface RemainingUnitsP {
  includeBuyback: boolean;
}

export function makeRemainingUnitsP(
  input: {
    includeBuyback?: boolean,
  }
): RemainingUnitsP {
  return {
    includeBuyback: input.includeBuyback === undefined ? false : input.includeBuyback,
  };
}

const RemainingUnitsP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"includeBuyback","default":{"kind":"just","value":false},"name":"includeBuyback","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"RemainingUnitsP","version":{"kind":"nothing"}}};

export const snRemainingUnitsP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"RemainingUnitsP"};

export function texprRemainingUnitsP(): ADL.ATypeExpr<RemainingUnitsP> {
  return {value : {typeRef : {kind: "reference", value : snRemainingUnitsP}, parameters : []}};
}

export interface RemainingUnitsBuybackE {
  date: common.LocalDate;
  units: number;
}

export function makeRemainingUnitsBuybackE(
  input: {
    date: common.LocalDate,
    units: number,
  }
): RemainingUnitsBuybackE {
  return {
    date: input.date,
    units: input.units,
  };
}

const RemainingUnitsBuybackE_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"date","default":{"kind":"nothing"},"name":"date","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"units","default":{"kind":"nothing"},"name":"units","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}]}},"name":"RemainingUnitsBuybackE","version":{"kind":"nothing"}}};

export const snRemainingUnitsBuybackE: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"RemainingUnitsBuybackE"};

export function texprRemainingUnitsBuybackE(): ADL.ATypeExpr<RemainingUnitsBuybackE> {
  return {value : {typeRef : {kind: "reference", value : snRemainingUnitsBuybackE}, parameters : []}};
}

export interface RemainingUnitsE {
  productCode: common_strings.StringNE;
  units: number;
  compulsory: RemainingUnitsBuybackE;
  final: RemainingUnitsBuybackE;
}

export function makeRemainingUnitsE(
  input: {
    productCode: common_strings.StringNE,
    units: number,
    compulsory: RemainingUnitsBuybackE,
    final: RemainingUnitsBuybackE,
  }
): RemainingUnitsE {
  return {
    productCode: input.productCode,
    units: input.units,
    compulsory: input.compulsory,
    final: input.final,
  };
}

const RemainingUnitsE_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"productCode","default":{"kind":"nothing"},"name":"productCode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"units","default":{"kind":"nothing"},"name":"units","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"compulsory","default":{"kind":"nothing"},"name":"compulsory","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"RemainingUnitsBuybackE"}},"parameters":[]}},{"annotations":[],"serializedName":"final","default":{"kind":"nothing"},"name":"final","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"RemainingUnitsBuybackE"}},"parameters":[]}}]}},"name":"RemainingUnitsE","version":{"kind":"nothing"}}};

export const snRemainingUnitsE: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"RemainingUnitsE"};

export function texprRemainingUnitsE(): ADL.ATypeExpr<RemainingUnitsE> {
  return {value : {typeRef : {kind: "reference", value : snRemainingUnitsE}, parameters : []}};
}

export type RemainingUnitsR = EType<RemainingUnitsE[]>;

const RemainingUnitsR_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EType"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"RemainingUnitsE"}},"parameters":[]}]}]}}},"name":"RemainingUnitsR","version":{"kind":"nothing"}}};

export const snRemainingUnitsR: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"RemainingUnitsR"};

export function texprRemainingUnitsR(): ADL.ATypeExpr<RemainingUnitsR> {
  return {value : {typeRef : {kind: "reference", value : snRemainingUnitsR}, parameters : []}};
}

export type RepurchaseType = 'expiryRoll' | 'newDealDelivery' | 'newDealLoss' | 'productionLoss' | 'productionRun' | 'revaluation' | 'saleOrder' | 'stockMovementRoll';
export const valuesRepurchaseType : RepurchaseType[] = ['expiryRoll', 'newDealDelivery', 'newDealLoss', 'productionLoss', 'productionRun', 'revaluation', 'saleOrder', 'stockMovementRoll'];

const RepurchaseType_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"expiryRoll","default":{"kind":"nothing"},"name":"expiryRoll","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"newDealDelivery","default":{"kind":"nothing"},"name":"newDealDelivery","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"newDealLoss","default":{"kind":"nothing"},"name":"newDealLoss","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"productionLoss","default":{"kind":"nothing"},"name":"productionLoss","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"productionRun","default":{"kind":"nothing"},"name":"productionRun","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"revaluation","default":{"kind":"nothing"},"name":"revaluation","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"saleOrder","default":{"kind":"nothing"},"name":"saleOrder","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"stockMovementRoll","default":{"kind":"nothing"},"name":"stockMovementRoll","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"RepurchaseType","version":{"kind":"nothing"}}};

export const snRepurchaseType: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"RepurchaseType"};

export function texprRepurchaseType(): ADL.ATypeExpr<RepurchaseType> {
  return {value : {typeRef : {kind: "reference", value : snRepurchaseType}, parameters : []}};
}

export interface RepurchaseP {
  includeTypes: (RepurchaseType[]|null);
  includeCanceled: boolean;
  fromDate: (common.LocalDate|null);
  toDate: (common.LocalDate|null);
}

export function makeRepurchaseP(
  input: {
    includeTypes?: (RepurchaseType[]|null),
    includeCanceled?: boolean,
    fromDate?: (common.LocalDate|null),
    toDate?: (common.LocalDate|null),
  }
): RepurchaseP {
  return {
    includeTypes: input.includeTypes === undefined ? null : input.includeTypes,
    includeCanceled: input.includeCanceled === undefined ? true : input.includeCanceled,
    fromDate: input.fromDate === undefined ? null : input.fromDate,
    toDate: input.toDate === undefined ? null : input.toDate,
  };
}

const RepurchaseP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"includeTypes","default":{"kind":"just","value":null},"name":"includeTypes","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"RepurchaseType"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"includeCanceled","default":{"kind":"just","value":true},"name":"includeCanceled","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"fromDate","default":{"kind":"just","value":null},"name":"fromDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"toDate","default":{"kind":"just","value":null},"name":"toDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}}]}},"name":"RepurchaseP","version":{"kind":"nothing"}}};

export const snRepurchaseP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"RepurchaseP"};

export function texprRepurchaseP(): ADL.ATypeExpr<RepurchaseP> {
  return {value : {typeRef : {kind: "reference", value : snRepurchaseP}, parameters : []}};
}

export interface RepurchaseE {
  date: common.LocalDate;
  invoiceNumber: string;
  productCode: string;
  price: common.BigDecimal;
  units: number;
  deliveryOption: ferovinum_app_db.DeliveryOption;
  repurchaseType: RepurchaseType;
  lastStatusEvent: (ferovinum_app_db.SaleOrderStatusEvent|null);
  dutyTotal: (common.BigDecimal|null);
  vatTotal: (common.BigDecimal|null);
}

export function makeRepurchaseE(
  input: {
    date: common.LocalDate,
    invoiceNumber: string,
    productCode: string,
    price: common.BigDecimal,
    units: number,
    deliveryOption: ferovinum_app_db.DeliveryOption,
    repurchaseType: RepurchaseType,
    lastStatusEvent?: (ferovinum_app_db.SaleOrderStatusEvent|null),
    dutyTotal?: (common.BigDecimal|null),
    vatTotal?: (common.BigDecimal|null),
  }
): RepurchaseE {
  return {
    date: input.date,
    invoiceNumber: input.invoiceNumber,
    productCode: input.productCode,
    price: input.price,
    units: input.units,
    deliveryOption: input.deliveryOption,
    repurchaseType: input.repurchaseType,
    lastStatusEvent: input.lastStatusEvent === undefined ? null : input.lastStatusEvent,
    dutyTotal: input.dutyTotal === undefined ? null : input.dutyTotal,
    vatTotal: input.vatTotal === undefined ? null : input.vatTotal,
  };
}

const RepurchaseE_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"date","default":{"kind":"nothing"},"name":"date","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"invoiceNumber","default":{"kind":"nothing"},"name":"invoiceNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"productCode","default":{"kind":"nothing"},"name":"productCode","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"price","default":{"kind":"nothing"},"name":"price","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"units","default":{"kind":"nothing"},"name":"units","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"deliveryOption","default":{"kind":"nothing"},"name":"deliveryOption","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DeliveryOption"}},"parameters":[]}},{"annotations":[],"serializedName":"repurchaseType","default":{"kind":"nothing"},"name":"repurchaseType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"RepurchaseType"}},"parameters":[]}},{"annotations":[],"serializedName":"lastStatusEvent","default":{"kind":"just","value":null},"name":"lastStatusEvent","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"SaleOrderStatusEvent"}},"parameters":[]}]}},{"annotations":[],"serializedName":"dutyTotal","default":{"kind":"just","value":null},"name":"dutyTotal","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}},{"annotations":[],"serializedName":"vatTotal","default":{"kind":"just","value":null},"name":"vatTotal","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}]}}]}},"name":"RepurchaseE","version":{"kind":"nothing"}}};

export const snRepurchaseE: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"RepurchaseE"};

export function texprRepurchaseE(): ADL.ATypeExpr<RepurchaseE> {
  return {value : {typeRef : {kind: "reference", value : snRepurchaseE}, parameters : []}};
}

export type RepurchaseR = EType<RepurchaseE[]>;

const RepurchaseR_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EType"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"RepurchaseE"}},"parameters":[]}]}]}}},"name":"RepurchaseR","version":{"kind":"nothing"}}};

export const snRepurchaseR: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"RepurchaseR"};

export function texprRepurchaseR(): ADL.ATypeExpr<RepurchaseR> {
  return {value : {typeRef : {kind: "reference", value : snRepurchaseR}, parameters : []}};
}

export interface StockMovementP {
  includeReserved: boolean;
}

export function makeStockMovementP(
  input: {
    includeReserved?: boolean,
  }
): StockMovementP {
  return {
    includeReserved: input.includeReserved === undefined ? false : input.includeReserved,
  };
}

const StockMovementP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"includeReserved","default":{"kind":"just","value":false},"name":"includeReserved","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"StockMovementP","version":{"kind":"nothing"}}};

export const snStockMovementP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"StockMovementP"};

export function texprStockMovementP(): ADL.ATypeExpr<StockMovementP> {
  return {value : {typeRef : {kind: "reference", value : snStockMovementP}, parameters : []}};
}

export interface StockMovementE {
  date: common.LocalDate;
  description: string;
  productCode: common_strings.StringNE;
  reference: string;
  storageLocationSiteCode: common_strings.StringNE;
  units: number;
}

export function makeStockMovementE(
  input: {
    date: common.LocalDate,
    description: string,
    productCode: common_strings.StringNE,
    reference: string,
    storageLocationSiteCode: common_strings.StringNE,
    units: number,
  }
): StockMovementE {
  return {
    date: input.date,
    description: input.description,
    productCode: input.productCode,
    reference: input.reference,
    storageLocationSiteCode: input.storageLocationSiteCode,
    units: input.units,
  };
}

const StockMovementE_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"date","default":{"kind":"nothing"},"name":"date","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"productCode","default":{"kind":"nothing"},"name":"productCode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"reference","default":{"kind":"nothing"},"name":"reference","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"storageLocationSiteCode","default":{"kind":"nothing"},"name":"storageLocationSiteCode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"units","default":{"kind":"nothing"},"name":"units","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}]}},"name":"StockMovementE","version":{"kind":"nothing"}}};

export const snStockMovementE: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"StockMovementE"};

export function texprStockMovementE(): ADL.ATypeExpr<StockMovementE> {
  return {value : {typeRef : {kind: "reference", value : snStockMovementE}, parameters : []}};
}

export type StockMovementR = EType<StockMovementE[]>;

const StockMovementR_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EType"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"StockMovementE"}},"parameters":[]}]}]}}},"name":"StockMovementR","version":{"kind":"nothing"}}};

export const snStockMovementR: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"StockMovementR"};

export function texprStockMovementR(): ADL.ATypeExpr<StockMovementR> {
  return {value : {typeRef : {kind: "reference", value : snStockMovementR}, parameters : []}};
}

export interface UnitsRemainingP {
  includeReserved: boolean;
  includeZeroBalance: boolean;
}

export function makeUnitsRemainingP(
  input: {
    includeReserved?: boolean,
    includeZeroBalance?: boolean,
  }
): UnitsRemainingP {
  return {
    includeReserved: input.includeReserved === undefined ? false : input.includeReserved,
    includeZeroBalance: input.includeZeroBalance === undefined ? false : input.includeZeroBalance,
  };
}

const UnitsRemainingP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"includeReserved","default":{"kind":"just","value":false},"name":"includeReserved","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"includeZeroBalance","default":{"kind":"just","value":false},"name":"includeZeroBalance","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"UnitsRemainingP","version":{"kind":"nothing"}}};

export const snUnitsRemainingP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"UnitsRemainingP"};

export function texprUnitsRemainingP(): ADL.ATypeExpr<UnitsRemainingP> {
  return {value : {typeRef : {kind: "reference", value : snUnitsRemainingP}, parameters : []}};
}

export interface UnitsRemainingBuybackE {
  date: common.LocalDate;
  units: number;
}

export function makeUnitsRemainingBuybackE(
  input: {
    date: common.LocalDate,
    units: number,
  }
): UnitsRemainingBuybackE {
  return {
    date: input.date,
    units: input.units,
  };
}

const UnitsRemainingBuybackE_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"date","default":{"kind":"nothing"},"name":"date","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"units","default":{"kind":"nothing"},"name":"units","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}]}},"name":"UnitsRemainingBuybackE","version":{"kind":"nothing"}}};

export const snUnitsRemainingBuybackE: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"UnitsRemainingBuybackE"};

export function texprUnitsRemainingBuybackE(): ADL.ATypeExpr<UnitsRemainingBuybackE> {
  return {value : {typeRef : {kind: "reference", value : snUnitsRemainingBuybackE}, parameters : []}};
}

export interface UnitsRemainingE {
  productCode: common_strings.StringNE;
  units: number;
  compulsory: UnitsRemainingBuybackE;
  final: UnitsRemainingBuybackE;
}

export function makeUnitsRemainingE(
  input: {
    productCode: common_strings.StringNE,
    units: number,
    compulsory: UnitsRemainingBuybackE,
    final: UnitsRemainingBuybackE,
  }
): UnitsRemainingE {
  return {
    productCode: input.productCode,
    units: input.units,
    compulsory: input.compulsory,
    final: input.final,
  };
}

const UnitsRemainingE_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"productCode","default":{"kind":"nothing"},"name":"productCode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"units","default":{"kind":"nothing"},"name":"units","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"compulsory","default":{"kind":"nothing"},"name":"compulsory","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"UnitsRemainingBuybackE"}},"parameters":[]}},{"annotations":[],"serializedName":"final","default":{"kind":"nothing"},"name":"final","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"UnitsRemainingBuybackE"}},"parameters":[]}}]}},"name":"UnitsRemainingE","version":{"kind":"nothing"}}};

export const snUnitsRemainingE: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"UnitsRemainingE"};

export function texprUnitsRemainingE(): ADL.ATypeExpr<UnitsRemainingE> {
  return {value : {typeRef : {kind: "reference", value : snUnitsRemainingE}, parameters : []}};
}

export type UnitsRemainingR = EType<UnitsRemainingE[]>;

const UnitsRemainingR_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EType"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"UnitsRemainingE"}},"parameters":[]}]}]}}},"name":"UnitsRemainingR","version":{"kind":"nothing"}}};

export const snUnitsRemainingR: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"UnitsRemainingR"};

export function texprUnitsRemainingR(): ADL.ATypeExpr<UnitsRemainingR> {
  return {value : {typeRef : {kind: "reference", value : snUnitsRemainingR}, parameters : []}};
}

export interface CapexReconciliationP {
  includePostDepletion: boolean;
  fromDate: (common.LocalDate|null);
  toDate: (common.LocalDate|null);
}

export function makeCapexReconciliationP(
  input: {
    includePostDepletion?: boolean,
    fromDate?: (common.LocalDate|null),
    toDate?: (common.LocalDate|null),
  }
): CapexReconciliationP {
  return {
    includePostDepletion: input.includePostDepletion === undefined ? true : input.includePostDepletion,
    fromDate: input.fromDate === undefined ? null : input.fromDate,
    toDate: input.toDate === undefined ? null : input.toDate,
  };
}

const CapexReconciliationP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"includePostDepletion","default":{"kind":"just","value":true},"name":"includePostDepletion","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"fromDate","default":{"kind":"just","value":null},"name":"fromDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"toDate","default":{"kind":"just","value":null},"name":"toDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}}]}},"name":"CapexReconciliationP","version":{"kind":"nothing"}}};

export const snCapexReconciliationP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"CapexReconciliationP"};

export function texprCapexReconciliationP(): ADL.ATypeExpr<CapexReconciliationP> {
  return {value : {typeRef : {kind: "reference", value : snCapexReconciliationP}, parameters : []}};
}

export interface CapexReconciliationE {
  capexId: ferovinum_app_db.CapitalisedExpenseId;
  dealLegId: ferovinum_app_db.DealLegId;
  expenseDate: common.LocalDate;
  depletedAt: (common.LocalDate|null);
  amountPaid: common.BigDecimal;
  spreadQuantity: common.BigDecimal;
  issue: string;
}

export function makeCapexReconciliationE(
  input: {
    capexId: ferovinum_app_db.CapitalisedExpenseId,
    dealLegId: ferovinum_app_db.DealLegId,
    expenseDate: common.LocalDate,
    depletedAt: (common.LocalDate|null),
    amountPaid: common.BigDecimal,
    spreadQuantity: common.BigDecimal,
    issue: string,
  }
): CapexReconciliationE {
  return {
    capexId: input.capexId,
    dealLegId: input.dealLegId,
    expenseDate: input.expenseDate,
    depletedAt: input.depletedAt,
    amountPaid: input.amountPaid,
    spreadQuantity: input.spreadQuantity,
    issue: input.issue,
  };
}

const CapexReconciliationE_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"capexId","default":{"kind":"nothing"},"name":"capexId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"CapitalisedExpenseId"}},"parameters":[]}},{"annotations":[],"serializedName":"dealLegId","default":{"kind":"nothing"},"name":"dealLegId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"DealLegId"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseDate","default":{"kind":"nothing"},"name":"expenseDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"depletedAt","default":{"kind":"nothing"},"name":"depletedAt","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"amountPaid","default":{"kind":"nothing"},"name":"amountPaid","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"spreadQuantity","default":{"kind":"nothing"},"name":"spreadQuantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"issue","default":{"kind":"nothing"},"name":"issue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"CapexReconciliationE","version":{"kind":"nothing"}}};

export const snCapexReconciliationE: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"CapexReconciliationE"};

export function texprCapexReconciliationE(): ADL.ATypeExpr<CapexReconciliationE> {
  return {value : {typeRef : {kind: "reference", value : snCapexReconciliationE}, parameters : []}};
}

export type CapexReconciliationR = EType<CapexReconciliationE[]>;

const CapexReconciliationR_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EType"}},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"CapexReconciliationE"}},"parameters":[]}]}]}}},"name":"CapexReconciliationR","version":{"kind":"nothing"}}};

export const snCapexReconciliationR: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"CapexReconciliationR"};

export function texprCapexReconciliationR(): ADL.ATypeExpr<CapexReconciliationR> {
  return {value : {typeRef : {kind: "reference", value : snCapexReconciliationR}, parameters : []}};
}

export interface Param_AttributeOp {
  kind: 'attributeOp';
  value: AttributeOpP;
}
export interface Param_Bag {
  kind: 'bag';
  value: BagP;
}
export interface Param_CapexReconciliation {
  kind: 'capexReconciliation';
  value: CapexReconciliationP;
}
export interface Param_Cashflow {
  kind: 'cashflow';
  value: CashflowP;
}
export interface Param_DealCount {
  kind: 'dealCount';
  value: DealCountP;
}
export interface Param_DealRollCount {
  kind: 'dealRollCount';
  value: DealRollCountP;
}
export interface Param_DealRollHistory {
  kind: 'dealRollHistory';
  value: DealRollHistoryP;
}
export interface Param_DepletionForecast {
  kind: 'depletionForecast';
  value: DepletionForecastP;
}
export interface Param_Fee {
  kind: 'fee';
  value: FeeP;
}
export interface Param_Fsp {
  kind: 'fsp';
  value: FspP;
}
export interface Param_FxSpot {
  kind: 'fxSpot';
  value: FxSpotP;
}
export interface Param_InitialUnits {
  kind: 'initialUnits';
  value: InitialUnitsP;
}
export interface Param_MonthlyFeeNextDate {
  kind: 'monthlyFeeNextDate';
  value: MonthlyFeeNextDateP;
}
export interface Param_PerDeal {
  kind: 'perDeal';
  value: PerDealP;
}
export interface Param_RemainingUnits {
  kind: 'remainingUnits';
  value: RemainingUnitsP;
}
export interface Param_Repurchase {
  kind: 'repurchase';
  value: RepurchaseP;
}
export interface Param_StockMovement {
  kind: 'stockMovement';
  value: StockMovementP;
}
export interface Param_UnitsRemaining {
  kind: 'unitsRemaining';
  value: UnitsRemainingP;
}

export type Param = Param_AttributeOp | Param_Bag | Param_CapexReconciliation | Param_Cashflow | Param_DealCount | Param_DealRollCount | Param_DealRollHistory | Param_DepletionForecast | Param_Fee | Param_Fsp | Param_FxSpot | Param_InitialUnits | Param_MonthlyFeeNextDate | Param_PerDeal | Param_RemainingUnits | Param_Repurchase | Param_StockMovement | Param_UnitsRemaining;

export interface ParamOpts {
  attributeOp: AttributeOpP;
  bag: BagP;
  capexReconciliation: CapexReconciliationP;
  cashflow: CashflowP;
  dealCount: DealCountP;
  dealRollCount: DealRollCountP;
  dealRollHistory: DealRollHistoryP;
  depletionForecast: DepletionForecastP;
  fee: FeeP;
  fsp: FspP;
  fxSpot: FxSpotP;
  initialUnits: InitialUnitsP;
  monthlyFeeNextDate: MonthlyFeeNextDateP;
  perDeal: PerDealP;
  remainingUnits: RemainingUnitsP;
  repurchase: RepurchaseP;
  stockMovement: StockMovementP;
  unitsRemaining: UnitsRemainingP;
}

export function makeParam<K extends keyof ParamOpts>(kind: K, value: ParamOpts[K]) { return {kind, value}; }

const Param_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"attributeOp","default":{"kind":"nothing"},"name":"attributeOp","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"AttributeOpP"}},"parameters":[]}},{"annotations":[],"serializedName":"bag","default":{"kind":"nothing"},"name":"bag","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"BagP"}},"parameters":[]}},{"annotations":[],"serializedName":"capexReconciliation","default":{"kind":"nothing"},"name":"capexReconciliation","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"CapexReconciliationP"}},"parameters":[]}},{"annotations":[],"serializedName":"cashflow","default":{"kind":"nothing"},"name":"cashflow","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"CashflowP"}},"parameters":[]}},{"annotations":[],"serializedName":"dealCount","default":{"kind":"nothing"},"name":"dealCount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"DealCountP"}},"parameters":[]}},{"annotations":[],"serializedName":"dealRollCount","default":{"kind":"nothing"},"name":"dealRollCount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"DealRollCountP"}},"parameters":[]}},{"annotations":[],"serializedName":"dealRollHistory","default":{"kind":"nothing"},"name":"dealRollHistory","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"DealRollHistoryP"}},"parameters":[]}},{"annotations":[],"serializedName":"depletionForecast","default":{"kind":"nothing"},"name":"depletionForecast","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"DepletionForecastP"}},"parameters":[]}},{"annotations":[],"serializedName":"fee","default":{"kind":"nothing"},"name":"fee","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"FeeP"}},"parameters":[]}},{"annotations":[],"serializedName":"fsp","default":{"kind":"nothing"},"name":"fsp","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"FspP"}},"parameters":[]}},{"annotations":[],"serializedName":"fxSpot","default":{"kind":"nothing"},"name":"fxSpot","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"FxSpotP"}},"parameters":[]}},{"annotations":[],"serializedName":"initialUnits","default":{"kind":"nothing"},"name":"initialUnits","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"InitialUnitsP"}},"parameters":[]}},{"annotations":[],"serializedName":"monthlyFeeNextDate","default":{"kind":"nothing"},"name":"monthlyFeeNextDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"MonthlyFeeNextDateP"}},"parameters":[]}},{"annotations":[],"serializedName":"perDeal","default":{"kind":"nothing"},"name":"perDeal","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"PerDealP"}},"parameters":[]}},{"annotations":[],"serializedName":"remainingUnits","default":{"kind":"nothing"},"name":"remainingUnits","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"RemainingUnitsP"}},"parameters":[]}},{"annotations":[],"serializedName":"repurchase","default":{"kind":"nothing"},"name":"repurchase","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"RepurchaseP"}},"parameters":[]}},{"annotations":[],"serializedName":"stockMovement","default":{"kind":"nothing"},"name":"stockMovement","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"StockMovementP"}},"parameters":[]}},{"annotations":[],"serializedName":"unitsRemaining","default":{"kind":"nothing"},"name":"unitsRemaining","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"UnitsRemainingP"}},"parameters":[]}}]}},"name":"Param","version":{"kind":"nothing"}}};

export const snParam: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"Param"};

export function texprParam(): ADL.ATypeExpr<Param> {
  return {value : {typeRef : {kind: "reference", value : snParam}, parameters : []}};
}

export interface Result_AttributeOp {
  kind: 'attributeOp';
  value: AttributeOpR;
}
export interface Result_Bag {
  kind: 'bag';
  value: BagR;
}
export interface Result_CapexReconciliation {
  kind: 'capexReconciliation';
  value: CapexReconciliationR;
}
export interface Result_Cashflow {
  kind: 'cashflow';
  value: CashflowR;
}
export interface Result_DealCount {
  kind: 'dealCount';
  value: DealCountR;
}
export interface Result_DealRollCount {
  kind: 'dealRollCount';
  value: DealRollCountR;
}
export interface Result_DealRollHistory {
  kind: 'dealRollHistory';
  value: DealRollHistoryR;
}
export interface Result_DepletionForecast {
  kind: 'depletionForecast';
  value: DepletionForecastR;
}
export interface Result_Fee {
  kind: 'fee';
  value: FeeR;
}
export interface Result_Fsp {
  kind: 'fsp';
  value: FspR;
}
export interface Result_FxSpot {
  kind: 'fxSpot';
  value: FxSpotR;
}
export interface Result_InitialUnits {
  kind: 'initialUnits';
  value: InitialUnitsR;
}
export interface Result_MonthlyFeeNextDate {
  kind: 'monthlyFeeNextDate';
  value: MonthlyFeeNextDateR;
}
export interface Result_PerDeal {
  kind: 'perDeal';
  value: PerDealR;
}
export interface Result_RemainingUnits {
  kind: 'remainingUnits';
  value: RemainingUnitsR;
}
export interface Result_Repurchase {
  kind: 'repurchase';
  value: RepurchaseR;
}
export interface Result_StockMovement {
  kind: 'stockMovement';
  value: StockMovementR;
}
export interface Result_UnitsRemaining {
  kind: 'unitsRemaining';
  value: UnitsRemainingR;
}

export type Result = Result_AttributeOp | Result_Bag | Result_CapexReconciliation | Result_Cashflow | Result_DealCount | Result_DealRollCount | Result_DealRollHistory | Result_DepletionForecast | Result_Fee | Result_Fsp | Result_FxSpot | Result_InitialUnits | Result_MonthlyFeeNextDate | Result_PerDeal | Result_RemainingUnits | Result_Repurchase | Result_StockMovement | Result_UnitsRemaining;

export interface ResultOpts {
  attributeOp: AttributeOpR;
  bag: BagR;
  capexReconciliation: CapexReconciliationR;
  cashflow: CashflowR;
  dealCount: DealCountR;
  dealRollCount: DealRollCountR;
  dealRollHistory: DealRollHistoryR;
  depletionForecast: DepletionForecastR;
  fee: FeeR;
  fsp: FspR;
  fxSpot: FxSpotR;
  initialUnits: InitialUnitsR;
  monthlyFeeNextDate: MonthlyFeeNextDateR;
  perDeal: PerDealR;
  remainingUnits: RemainingUnitsR;
  repurchase: RepurchaseR;
  stockMovement: StockMovementR;
  unitsRemaining: UnitsRemainingR;
}

export function makeResult<K extends keyof ResultOpts>(kind: K, value: ResultOpts[K]) { return {kind, value}; }

const Result_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"attributeOp","default":{"kind":"nothing"},"name":"attributeOp","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"AttributeOpR"}},"parameters":[]}},{"annotations":[],"serializedName":"bag","default":{"kind":"nothing"},"name":"bag","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"BagR"}},"parameters":[]}},{"annotations":[],"serializedName":"capexReconciliation","default":{"kind":"nothing"},"name":"capexReconciliation","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"CapexReconciliationR"}},"parameters":[]}},{"annotations":[],"serializedName":"cashflow","default":{"kind":"nothing"},"name":"cashflow","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"CashflowR"}},"parameters":[]}},{"annotations":[],"serializedName":"dealCount","default":{"kind":"nothing"},"name":"dealCount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"DealCountR"}},"parameters":[]}},{"annotations":[],"serializedName":"dealRollCount","default":{"kind":"nothing"},"name":"dealRollCount","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"DealRollCountR"}},"parameters":[]}},{"annotations":[],"serializedName":"dealRollHistory","default":{"kind":"nothing"},"name":"dealRollHistory","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"DealRollHistoryR"}},"parameters":[]}},{"annotations":[],"serializedName":"depletionForecast","default":{"kind":"nothing"},"name":"depletionForecast","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"DepletionForecastR"}},"parameters":[]}},{"annotations":[],"serializedName":"fee","default":{"kind":"nothing"},"name":"fee","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"FeeR"}},"parameters":[]}},{"annotations":[],"serializedName":"fsp","default":{"kind":"nothing"},"name":"fsp","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"FspR"}},"parameters":[]}},{"annotations":[],"serializedName":"fxSpot","default":{"kind":"nothing"},"name":"fxSpot","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"FxSpotR"}},"parameters":[]}},{"annotations":[],"serializedName":"initialUnits","default":{"kind":"nothing"},"name":"initialUnits","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"InitialUnitsR"}},"parameters":[]}},{"annotations":[],"serializedName":"monthlyFeeNextDate","default":{"kind":"nothing"},"name":"monthlyFeeNextDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"MonthlyFeeNextDateR"}},"parameters":[]}},{"annotations":[],"serializedName":"perDeal","default":{"kind":"nothing"},"name":"perDeal","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"PerDealR"}},"parameters":[]}},{"annotations":[],"serializedName":"remainingUnits","default":{"kind":"nothing"},"name":"remainingUnits","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"RemainingUnitsR"}},"parameters":[]}},{"annotations":[],"serializedName":"repurchase","default":{"kind":"nothing"},"name":"repurchase","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"RepurchaseR"}},"parameters":[]}},{"annotations":[],"serializedName":"stockMovement","default":{"kind":"nothing"},"name":"stockMovement","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"StockMovementR"}},"parameters":[]}},{"annotations":[],"serializedName":"unitsRemaining","default":{"kind":"nothing"},"name":"unitsRemaining","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"UnitsRemainingR"}},"parameters":[]}}]}},"name":"Result","version":{"kind":"nothing"}}};

export const snResult: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"Result"};

export function texprResult(): ADL.ATypeExpr<Result> {
  return {value : {typeRef : {kind: "reference", value : snResult}, parameters : []}};
}

export interface DealsLoader {
  filter: common_tabular.FieldPredicate;
  organisations: sys_types.Set<string>;
  onlyLive: boolean;
  liveOn: (common.LocalDate|null);
  includeDepleted: boolean;
  depletedOn: (common.LocalDate|null);
}

export function makeDealsLoader(
  input: {
    filter?: common_tabular.FieldPredicate,
    organisations?: sys_types.Set<string>,
    onlyLive?: boolean,
    liveOn?: (common.LocalDate|null),
    includeDepleted?: boolean,
    depletedOn?: (common.LocalDate|null),
  }
): DealsLoader {
  return {
    filter: input.filter === undefined ? {kind : "literal", value : true} : input.filter,
    organisations: input.organisations === undefined ? [] : input.organisations,
    onlyLive: input.onlyLive === undefined ? true : input.onlyLive,
    liveOn: input.liveOn === undefined ? null : input.liveOn,
    includeDepleted: input.includeDepleted === undefined ? false : input.includeDepleted,
    depletedOn: input.depletedOn === undefined ? null : input.depletedOn,
  };
}

const DealsLoader_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"filter","default":{"kind":"just","value":{"literal":true}},"name":"filter","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.tabular","name":"FieldPredicate"}},"parameters":[]}},{"annotations":[],"serializedName":"organisations","default":{"kind":"just","value":[]},"name":"organisations","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"sys.types","name":"Set"}},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"onlyLive","default":{"kind":"just","value":true},"name":"onlyLive","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"liveOn","default":{"kind":"just","value":null},"name":"liveOn","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"includeDepleted","default":{"kind":"just","value":false},"name":"includeDepleted","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"depletedOn","default":{"kind":"just","value":null},"name":"depletedOn","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}}]}},"name":"DealsLoader","version":{"kind":"nothing"}}};

export const snDealsLoader: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"DealsLoader"};

export function texprDealsLoader(): ADL.ATypeExpr<DealsLoader> {
  return {value : {typeRef : {kind: "reference", value : snDealsLoader}, parameters : []}};
}

export interface FormatterP_Csv {
  kind: 'csv';
  value: CsvP;
}
export interface FormatterP_Json {
  kind: 'json';
  value: JsonP;
}
export interface FormatterP_Tabular {
  kind: 'tabular';
  value: TabularP;
}

export type FormatterP = FormatterP_Csv | FormatterP_Json | FormatterP_Tabular;

export interface FormatterPOpts {
  csv: CsvP;
  json: JsonP;
  tabular: TabularP;
}

export function makeFormatterP<K extends keyof FormatterPOpts>(kind: K, value: FormatterPOpts[K]) { return {kind, value}; }

const FormatterP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"csv","default":{"kind":"nothing"},"name":"csv","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"CsvP"}},"parameters":[]}},{"annotations":[],"serializedName":"json","default":{"kind":"nothing"},"name":"json","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"JsonP"}},"parameters":[]}},{"annotations":[],"serializedName":"tabular","default":{"kind":"nothing"},"name":"tabular","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"TabularP"}},"parameters":[]}}]}},"name":"FormatterP","version":{"kind":"nothing"}}};

export const snFormatterP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"FormatterP"};

export function texprFormatterP(): ADL.ATypeExpr<FormatterP> {
  return {value : {typeRef : {kind: "reference", value : snFormatterP}, parameters : []}};
}

export interface CsvP {
  quoteCharacter: string;
}

export function makeCsvP(
  input: {
    quoteCharacter?: string,
  }
): CsvP {
  return {
    quoteCharacter: input.quoteCharacter === undefined ? "" : input.quoteCharacter,
  };
}

const CsvP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"quoteCharacter","default":{"kind":"just","value":""},"name":"quoteCharacter","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"CsvP","version":{"kind":"nothing"}}};

export const snCsvP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"CsvP"};

export function texprCsvP(): ADL.ATypeExpr<CsvP> {
  return {value : {typeRef : {kind: "reference", value : snCsvP}, parameters : []}};
}

export interface JsonP {
  indentSize: number;
}

export function makeJsonP(
  input: {
    indentSize?: number,
  }
): JsonP {
  return {
    indentSize: input.indentSize === undefined ? 2 : input.indentSize,
  };
}

const JsonP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"indentSize","default":{"kind":"just","value":2},"name":"indentSize","typeExpr":{"typeRef":{"kind":"primitive","value":"Word32"},"parameters":[]}}]}},"name":"JsonP","version":{"kind":"nothing"}}};

export const snJsonP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"JsonP"};

export function texprJsonP(): ADL.ATypeExpr<JsonP> {
  return {value : {typeRef : {kind: "reference", value : snJsonP}, parameters : []}};
}

export interface TabularP {
  unstackReportName: boolean;
  throwOverlapColumnName: boolean;
}

export function makeTabularP(
  input: {
    unstackReportName?: boolean,
    throwOverlapColumnName?: boolean,
  }
): TabularP {
  return {
    unstackReportName: input.unstackReportName === undefined ? false : input.unstackReportName,
    throwOverlapColumnName: input.throwOverlapColumnName === undefined ? false : input.throwOverlapColumnName,
  };
}

const TabularP_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"unstackReportName","default":{"kind":"just","value":false},"name":"unstackReportName","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"throwOverlapColumnName","default":{"kind":"just","value":false},"name":"throwOverlapColumnName","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"TabularP","version":{"kind":"nothing"}}};

export const snTabularP: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"TabularP"};

export function texprTabularP(): ADL.ATypeExpr<TabularP> {
  return {value : {typeRef : {kind: "reference", value : snTabularP}, parameters : []}};
}

export type Record = {[key: string]: EValue};

const Record_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"StringMap"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"EValue"}},"parameters":[]}]}}},"name":"Record","version":{"kind":"nothing"}}};

export const snRecord: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"Record"};

export function texprRecord(): ADL.ATypeExpr<Record> {
  return {value : {typeRef : {kind: "reference", value : snRecord}, parameters : []}};
}

export interface Table {
  records: Record[];
}

export function makeTable(
  input: {
    records: Record[],
  }
): Table {
  return {
    records: input.records,
  };
}

const Table_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"records","default":{"kind":"nothing"},"name":"records","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"Record"}},"parameters":[]}]}}]}},"name":"Table","version":{"kind":"nothing"}}};

export const snTable: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"Table"};

export function texprTable(): ADL.ATypeExpr<Table> {
  return {value : {typeRef : {kind: "reference", value : snTable}, parameters : []}};
}

export interface FormatterR_Csv {
  kind: 'csv';
  value: string;
}
export interface FormatterR_Json {
  kind: 'json';
  value: {}|null;
}
export interface FormatterR_Tabular {
  kind: 'tabular';
  value: Table;
}

export type FormatterR = FormatterR_Csv | FormatterR_Json | FormatterR_Tabular;

export interface FormatterROpts {
  csv: string;
  json: {}|null;
  tabular: Table;
}

export function makeFormatterR<K extends keyof FormatterROpts>(kind: K, value: FormatterROpts[K]) { return {kind, value}; }

const FormatterR_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"csv","default":{"kind":"nothing"},"name":"csv","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"json","default":{"kind":"nothing"},"name":"json","typeExpr":{"typeRef":{"kind":"primitive","value":"Json"},"parameters":[]}},{"annotations":[],"serializedName":"tabular","default":{"kind":"nothing"},"name":"tabular","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"Table"}},"parameters":[]}}]}},"name":"FormatterR","version":{"kind":"nothing"}}};

export const snFormatterR: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"FormatterR"};

export function texprFormatterR(): ADL.ATypeExpr<FormatterR> {
  return {value : {typeRef : {kind: "reference", value : snFormatterR}, parameters : []}};
}

export interface ReportReq {
  dealsLoader: DealsLoader;
  refDate: common.LocalDate;
  reportParam: Param;
  formatter: (FormatterP|null);
}

export function makeReportReq(
  input: {
    dealsLoader: DealsLoader,
    refDate: common.LocalDate,
    reportParam: Param,
    formatter?: (FormatterP|null),
  }
): ReportReq {
  return {
    dealsLoader: input.dealsLoader,
    refDate: input.refDate,
    reportParam: input.reportParam,
    formatter: input.formatter === undefined ? null : input.formatter,
  };
}

const ReportReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"dealsLoader","default":{"kind":"nothing"},"name":"dealsLoader","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"DealsLoader"}},"parameters":[]}},{"annotations":[],"serializedName":"refDate","default":{"kind":"nothing"},"name":"refDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"reportParam","default":{"kind":"nothing"},"name":"reportParam","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"Param"}},"parameters":[]}},{"annotations":[],"serializedName":"formatter","default":{"kind":"just","value":null},"name":"formatter","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"FormatterP"}},"parameters":[]}]}}]}},"name":"ReportReq","version":{"kind":"nothing"}}};

export const snReportReq: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"ReportReq"};

export function texprReportReq(): ADL.ATypeExpr<ReportReq> {
  return {value : {typeRef : {kind: "reference", value : snReportReq}, parameters : []}};
}

export interface ReportResp {
  result: Result;
  output: (FormatterR|null);
}

export function makeReportResp(
  input: {
    result: Result,
    output?: (FormatterR|null),
  }
): ReportResp {
  return {
    result: input.result,
    output: input.output === undefined ? null : input.output,
  };
}

const ReportResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.reporting","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"result","default":{"kind":"nothing"},"name":"result","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"Result"}},"parameters":[]}},{"annotations":[],"serializedName":"output","default":{"kind":"just","value":null},"name":"output","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.reporting","name":"FormatterR"}},"parameters":[]}]}}]}},"name":"ReportResp","version":{"kind":"nothing"}}};

export const snReportResp: ADL.ScopedName = {moduleName:"ferovinum.app.reporting", name:"ReportResp"};

export function texprReportResp(): ADL.ATypeExpr<ReportResp> {
  return {value : {typeRef : {kind: "reference", value : snReportResp}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.reporting.Value" : Value_AST,
  "ferovinum.app.reporting.Error" : Error_AST,
  "ferovinum.app.reporting.EType" : EType_AST,
  "ferovinum.app.reporting.EValue" : EValue_AST,
  "ferovinum.app.reporting.BiFunctionInput" : BiFunctionInput_AST,
  "ferovinum.app.reporting.Operator" : Operator_AST,
  "ferovinum.app.reporting.AttributeOpP" : AttributeOpP_AST,
  "ferovinum.app.reporting.AttributeOpE" : AttributeOpE_AST,
  "ferovinum.app.reporting.AttributeOpR" : AttributeOpR_AST,
  "ferovinum.app.reporting.BagP" : BagP_AST,
  "ferovinum.app.reporting.BagR" : BagR_AST,
  "ferovinum.app.reporting.FxSpotP" : FxSpotP_AST,
  "ferovinum.app.reporting.FxSpotE" : FxSpotE_AST,
  "ferovinum.app.reporting.FxSpotR" : FxSpotR_AST,
  "ferovinum.app.reporting.CashflowP" : CashflowP_AST,
  "ferovinum.app.reporting.CashflowE" : CashflowE_AST,
  "ferovinum.app.reporting.CashflowR" : CashflowR_AST,
  "ferovinum.app.reporting.DealCountP" : DealCountP_AST,
  "ferovinum.app.reporting.DealCountR" : DealCountR_AST,
  "ferovinum.app.reporting.DealRollCountP" : DealRollCountP_AST,
  "ferovinum.app.reporting.DealRollCountR" : DealRollCountR_AST,
  "ferovinum.app.reporting.DealRollHistoryP" : DealRollHistoryP_AST,
  "ferovinum.app.reporting.DealRollHistoryE" : DealRollHistoryE_AST,
  "ferovinum.app.reporting.DealRollHistoryR" : DealRollHistoryR_AST,
  "ferovinum.app.reporting.DepletionForecastP" : DepletionForecastP_AST,
  "ferovinum.app.reporting.DepletionForecastE" : DepletionForecastE_AST,
  "ferovinum.app.reporting.DepletionForecastR" : DepletionForecastR_AST,
  "ferovinum.app.reporting.FeeP" : FeeP_AST,
  "ferovinum.app.reporting.FeeE" : FeeE_AST,
  "ferovinum.app.reporting.FeeR" : FeeR_AST,
  "ferovinum.app.reporting.FspP" : FspP_AST,
  "ferovinum.app.reporting.FspCapExE" : FspCapExE_AST,
  "ferovinum.app.reporting.FspE" : FspE_AST,
  "ferovinum.app.reporting.FspR" : FspR_AST,
  "ferovinum.app.reporting.InitialUnitsP" : InitialUnitsP_AST,
  "ferovinum.app.reporting.InitialUnitsE" : InitialUnitsE_AST,
  "ferovinum.app.reporting.InitialUnitsR" : InitialUnitsR_AST,
  "ferovinum.app.reporting.MonthlyFeeNextDateP" : MonthlyFeeNextDateP_AST,
  "ferovinum.app.reporting.MonthlyFeeNextDateR" : MonthlyFeeNextDateR_AST,
  "ferovinum.app.reporting.PerDealP" : PerDealP_AST,
  "ferovinum.app.reporting.PerDealE" : PerDealE_AST,
  "ferovinum.app.reporting.PerDealR" : PerDealR_AST,
  "ferovinum.app.reporting.RemainingUnitsP" : RemainingUnitsP_AST,
  "ferovinum.app.reporting.RemainingUnitsBuybackE" : RemainingUnitsBuybackE_AST,
  "ferovinum.app.reporting.RemainingUnitsE" : RemainingUnitsE_AST,
  "ferovinum.app.reporting.RemainingUnitsR" : RemainingUnitsR_AST,
  "ferovinum.app.reporting.RepurchaseType" : RepurchaseType_AST,
  "ferovinum.app.reporting.RepurchaseP" : RepurchaseP_AST,
  "ferovinum.app.reporting.RepurchaseE" : RepurchaseE_AST,
  "ferovinum.app.reporting.RepurchaseR" : RepurchaseR_AST,
  "ferovinum.app.reporting.StockMovementP" : StockMovementP_AST,
  "ferovinum.app.reporting.StockMovementE" : StockMovementE_AST,
  "ferovinum.app.reporting.StockMovementR" : StockMovementR_AST,
  "ferovinum.app.reporting.UnitsRemainingP" : UnitsRemainingP_AST,
  "ferovinum.app.reporting.UnitsRemainingBuybackE" : UnitsRemainingBuybackE_AST,
  "ferovinum.app.reporting.UnitsRemainingE" : UnitsRemainingE_AST,
  "ferovinum.app.reporting.UnitsRemainingR" : UnitsRemainingR_AST,
  "ferovinum.app.reporting.CapexReconciliationP" : CapexReconciliationP_AST,
  "ferovinum.app.reporting.CapexReconciliationE" : CapexReconciliationE_AST,
  "ferovinum.app.reporting.CapexReconciliationR" : CapexReconciliationR_AST,
  "ferovinum.app.reporting.Param" : Param_AST,
  "ferovinum.app.reporting.Result" : Result_AST,
  "ferovinum.app.reporting.DealsLoader" : DealsLoader_AST,
  "ferovinum.app.reporting.FormatterP" : FormatterP_AST,
  "ferovinum.app.reporting.CsvP" : CsvP_AST,
  "ferovinum.app.reporting.JsonP" : JsonP_AST,
  "ferovinum.app.reporting.TabularP" : TabularP_AST,
  "ferovinum.app.reporting.Record" : Record_AST,
  "ferovinum.app.reporting.Table" : Table_AST,
  "ferovinum.app.reporting.FormatterR" : FormatterR_AST,
  "ferovinum.app.reporting.ReportReq" : ReportReq_AST,
  "ferovinum.app.reporting.ReportResp" : ReportResp_AST
};
